import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { useOptionalAuth } from '@/hooks/useOptionalAuth';
import { getMilestone } from '@/lib/points';
import MilestoneEmblem from '@/components/MilestoneEmblem';
import './MilestoneCelebration.css';

const MilestoneCelebration: React.FC = () => {
  const { t } = useTranslation();
  const auth = useOptionalAuth();
  const token = auth?.token;
  const user = auth?.user;
  const ident = user?.id ?? user?.username;
  const [shown, setShown] = useState<{ level: number; title: string } | null>(
    null,
  );

  const { data } = useQuery({
    queryKey: ['points', 'milestone', ident],
    queryFn: () => getMilestone(token as string, String(ident)),
    enabled: !!token && !!ident,
  });

  useEffect(() => {
    if (!data || !ident) return;
    const key = `milestone:${ident}`;
    const stored = Number(localStorage.getItem(key) ?? '0');
    if (data.current_level > stored) {
      setShown({ level: data.current_level, title: data.current_title });
      localStorage.setItem(key, String(data.current_level));
    }
  }, [data, ident]);

  if (!shown) return null;

  return (
    <div
      className="milestone-celebrate"
      role="dialog"
      aria-label={t('common.milestone.reached')}
    >
      <div className="milestone-celebrate__card">
        <div className="milestone-celebrate__emblem">
          <MilestoneEmblem level={shown.level} size={140} state="earned" />
        </div>
        <p className="milestone-celebrate__eyebrow">
          {t('common.milestone.reached')}
        </p>
        <p className="milestone-celebrate__title">{shown.title}</p>
        <button
          className="milestone-celebrate__btn"
          onClick={() => setShown(null)}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default MilestoneCelebration;
